module.exports = __webpack_public_path__ + "img/avatar2.b0183240.png";